<template>
    <div
        class="l-filter column-between-start"
        v-scroll="scrollListener"
    >
        <div class="l-filter-search row-start s-align-4">
            <search-icon/>
            <input
                type="text"
                name="leads_search"
                class="l-filter-input"
                placeholder="Filter Results"
                v-model="filtersInput"
            />
        </div>
        <perfect-scrollbar
            id="container-filters"
            class="ps-grey flex-grow-1"
        >
            <lead-filter-section
                :count-elements="milestones && milestones.length"
                :class="{ hide: checkFilterVisibility('Milestones') }"
                keyFilter="Milestones"
            >
                <span slot="filter-head">Milestones</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in milestones"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="yellow"
                            :label="item.title"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                :name="'milestone_' + index"
                                :id="'milestone_' + index"
                                v-model="filters.milestones"
                                :value="item.title"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="assignedFiltered && assignedFiltered.length"
                :class="{ hide: checkFilterVisibility('Assigned To') }"
                keyFilter="assigned-to"
            >
                <span slot="filter-head">Assigned To</span>
                <div slot="filter-list">
                    <div class="row-between bb-grey mb-7">
                        <checkbox-button
                            color="violet"
                            label="Active users"
                            class="f-13-black f-sbold w-60"
                        >
                            <input
                                type="checkbox"
                                name="active"
                                id="active_users"
                                v-model="users.active"
                                @change="filterUsersByActive(USERS_FILTER_BY.ACTIVE)"
                            />
                        </checkbox-button>
                        <checkbox-button
                            color="violet"
                            label="All users"
                            class="f-13-black f-sbold w-40"
                        >
                            <input
                                type="checkbox"
                                name="all"
                                id="all_users"
                                v-model="users.all"
                                @change="filterUsersByActive(USERS_FILTER_BY.ALL)"
                            />
                        </checkbox-button>
                    </div>
                    <div
                        class="row-between"
                        v-for="(item, index) in assignedFiltered"
                        :key="index"
                    >
                        <div class="s-align-4 w-85">
                            <checkbox-button
                                color="violet"
                                :label="item.fullname"
                                class="f-13-black f-sbold w-100"
                            >
                                <input
                                    type="checkbox"
                                    name="assigned"
                                    :id="'assigned' + index"
                                    v-model="filters.assigned"
                                    :value="item.fullname"
                                />
                            </checkbox-button>
                        </div>
                        <div class="s-align-6">
                            <span class="f-12-grey">
                                {{ item.count }}
                            </span>
                        </div>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="priorities && priorities.length"
                :class="[
                    'l-filter-priority',
                    { hide: checkFilterVisibility('Lead Priority') }
                ]"
                keyFilter="lead-priority"
            >
                <span slot="filter-head">Lead Priority</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in priorities"
                    :key="index"
                >
                    <priority-checkbox
                        :priorityColor="item.color_code"
                        :priority="item.name"
                        :id="item.name"
                        :filters="filters.priorities"
                        class="pointer"
                    >
                        <input
                            type="checkbox"
                            name="job-priority"
                            :id="'job-priority' + index"
                            v-model="filters.priorities"
                            :value="item.name"
                        />
                    </priority-checkbox>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="leadTypes && leadTypes.length"
                :class="{ hide: checkFilterVisibility('Job Types') }"
                keyFilter="lead-types"
            >
                <span slot="filter-head">Job Types</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in leadTypes"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="green"
                            :label="item.name"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                name="lead-type"
                                :id="'lead-type' + index"
                                v-model="filters.types"
                                :value="item.name"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="property && property.length"
                :class="{ hide: checkFilterVisibility('Property') }"
                keyFilter="property"
            >
                <span slot="filter-head">Property</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in property"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="green"
                            :label="item.property_name"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                name="lead-source"
                                :id="'lead-source-' + index"
                                v-model="filters.properties"
                                :value="item.property_name"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="customer && customer.length"
                :class="{ hide: checkFilterVisibility('Responsible billing party') }"
                keyFilter="responsible"
            >
                <span slot="filter-head">Responsible billing party</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in customer"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="red"
                            :label="item.customer_name"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                :name="'customer-' + index"
                                :id="'customer-' + index"
                                v-model="filters.customers"
                                :value="item.customer_name"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="workTypes && workTypes.length"
                :class="{ hide: checkFilterVisibility('Home Type') }"
                keyFilter="home-type"
            >
                <span slot="filter-head">Home Type</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in workTypes"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="dark"
                            :label="item.name"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                name="work-type"
                                :id="'work-type' + index"
                                v-model="filters.work_types"
                                :value="item.name"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>
            <lead-filter-section
                :count-elements="leadSources && leadSources.length"
                :class="{ hide: checkFilterVisibility('Lead Source') }"
                keyFilter="lead-source"
            >
                <span slot="filter-head">Lead Source</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in leadSources"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="blue"
                            :label="item.name"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                name="lead-source"
                                :id="'lead-source-' + index"
                                v-model="filters.sources"
                                :value="item.name"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>

            <lead-filter-section
                :count-elements="locationsLeads && locationsLeads.length"
                :class="{ hide: checkFilterVisibility('City, State') }"
                keyFilter="city"
            >
                <span slot="filter-head">City, State</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in locationsLeads"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="orange"
                            :label="item.location"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                name="locations-jobs"
                                :id="'locations-jobs' + index"
                                v-model="filters.locations"
                                :value="item.location"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-12-grey">
                            {{ item.count }}
                        </span>
                    </div>
                </div>
            </lead-filter-section>

            <lead-filter-section :class="{ hide: checkFilterVisibility('Trade') }">
                <span slot="filter-head">Trade</span>
                <div
                    slot="filter-list"
                    class="row-between"
                    v-for="(item, index) in trades"
                    :key="index"
                >
                    <div class="s-align-4 w-85">
                        <checkbox-button
                            color="red"
                            :label="item.name"
                            class="f-13-black f-sbold w-100"
                        >
                            <input
                                type="checkbox"
                                name="trades"
                                :id="'trades' + index"
                                v-model="filters.trades"
                                :value="item.id"
                            />
                        </checkbox-button>
                    </div>
                    <div class="s-align-6">
                        <span class="f-13-black f-sbold">{{ item.count }}</span>
                    </div>
                </div>
            </lead-filter-section>
        </perfect-scrollbar>
        <div class="w-100 l-filter-expand-all">
            <checkbox-button
                class="ph-20 pv-15 s-align-1 w-100 f-12-black"
                color="grey"
                label="Expand all items"
            >
                <input
                    type="checkbox"
                    name="expand_all"
                    id="expand_all"
                    v-model="isExpandAll"
                    @change="checkExpandAll"
                />
            </checkbox-button>
        </div>
    </div>
</template>

<script>
    import { SearchIcon, ArrowIcon } from '@/icons';
    import { CheckboxButton, PriorityCheckbox } from '@/ui';
    import { LeadFilterSection } from '@/components';
    import api from '@/headers.js';
    import debounce from 'lodash/debounce';
    import { BASE_ENTITY_TYPES } from '@/constants';
    import isEmpty from 'lodash/isEmpty';

    const USERS_FILTER_BY = {
        ALL: "all",
        ACTIVE: "active"
    };

    export default {
        name: 'CommercialLeadsFilter',
        props: [],
        components: {
            SearchIcon,
            ArrowIcon,
            CheckboxButton,
            LeadFilterSection,
            PriorityCheckbox
        },
        data() {
            return {
                USERS_FILTER_BY,
                priorities: [],
                // categories: [],
                workTypes: [],
                trades: [],
                locationsLeads: [],
                assigned: [],
                leadSources: [],
                customer: [],
                property: [],
                leadTypes: [],
                milestones: [],
                filters: {
                    priorities: [],
                    work_types: [],
                    trades: [],
                    locations: [],
                    assigned: [],
                    sources: [],
                    customers: [],
                    types: [],
                    properties:[],
                    milestones: []
                },
                filtersInput: '',
                isExpandAll: true,
                users: {
                    all: false,
                    active: true
                }
            }
        },
        computed: {
            assignedFiltered() {
                if (this.assigned && this.assigned.length) {
                    if (this.users.active) {
                        return this.assigned.filter((a) => {
                            return a.is_active == this.users.active;
                        });
                    } else {
                        return this.assigned;
                    }
                } else {
                    return [];
                }
            }
        },
        watch: {
            filters: {
                handler(newValue, oldValue) {
                    this.checkFilter(newValue);
                },
                deep: true
            }
        },
        methods: {
            checkExpandAll() {
                this.$store.commit('filters/SET_EXPAND_ALL', this.isExpandAll);
                if (!this.isExpandAll) {
                    document.getElementById('container-filters').scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            },
            getData() {
                const params = {
                    needed: [
                        "customerLeads",
                        "propertyLeads",
                        "tradeLeads",
                        "typeLeads",
                        "leadSourceLeads",
                        "assigneeLeads",
                        "priorityLeads",
                        "workTypeLeads",
                        "locationsLeads",
                        "milestones"
                    ],
                    entityType: BASE_ENTITY_TYPES.COMMERCIAL_LEAD
                };

                api.get('/handbooks', { params })
                    .then(response => response.data.data)
                    .then(data => {
                        this.priorities = data.priorityLeads;
                        this.workTypes = data.workTypeLeads;
                        this.locationsLeads = data.locationsLeads;
                        this.trades = data.tradeLeads;
                        this.assigned = data.assigneeLeads;
                        this.leadSources = data.leadSourceLeads;
                        this.leadTypes = data.typeLeads;
                        this.customer = data.customerLeads;
                        this.property = data.propertyLeads;
                        this.milestones= data.milestones;
                    })
                    .catch(error => {
                        this.notifyRequestErrors(error);
                    });
            },
            checkFilter: debounce(function (value) {
                let updatedFilter = {};
                for (const item in value) {
                    value[item].length ? updatedFilter[item] = value[item] : '';
                };

                this.$emit('filters', updatedFilter);
            }, 500),
            checkFilterVisibility(filterName) {
                return !filterName.toLowerCase().includes(this.filtersInput.toLowerCase());
            },
            scrollListener: function (event, el) {
                if (window.innerWidth > 1165) {
                    window.scrollY > 50
                        ? el.style.paddingTop = 70 + 'px'
                        : el.style.paddingTop = 150 + 'px';
                } else {
                    return false;
                }
            },
            prepareFilters() {
                if (!isEmpty(this.$route.query)) {

                    Object.keys(this.$route.query).map(q => {
                        if (q == 'locations') {
                            this.filters[q] = this.$route.query[q].match(/[a-z.\s]+,[a-z.\s]+/ig);
                        } else {
                            this.filters[q] = this.$route.query[q].split(",");
                        }
                    });
                }
                return Promise.resolve();
            },
            filterUsersByActive(userBy) {
                if (userBy === USERS_FILTER_BY.ACTIVE && this.users.all) {
                    this.users.all = false;
                }

                if (userBy === USERS_FILTER_BY.ALL && this.users.active) {
                    this.users.active = false;
                }
            }
        },
        created() {
            this.prepareFilters().then(() => {
                this.getData();
            });
        }
    }
</script>
